var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenanceLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5677 100.594H79.4321C83.7247 100.594 87.1392 97.0621 86.6775 92.9929C83.6965 66.7734 65.9062 67.207 65.9062 55.5C65.9062 43.793 83.9241 44.4434 86.6753 18.0071C87.1089 13.9357 83.7247 10.4062 79.4321 10.4062H31.5677C27.2751 10.4062 23.8996 13.9357 24.3245 18.0071C27.0757 44.4434 45.0937 43.5762 45.0937 55.5C45.0937 67.4238 27.3033 66.7734 24.3245 92.9929C23.8606 97.0621 27.2751 100.594 31.5677 100.594Z",
    stroke: "url(#paint0_linear_3708_396)",
    strokeWidth: 6.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4259 93.6562H36.6664C33.2843 93.6562 32.3304 89.7539 34.7022 87.3345C40.443 81.5156 52.0308 77.3488 52.0308 70.6758V48.5625C52.0308 44.2591 43.7925 40.9746 38.6956 33.9938C37.8544 32.8426 37.939 31.2188 40.0766 31.2188H71.02C72.8433 31.2188 73.2378 32.8296 72.4075 33.9829C67.3843 40.9746 58.9683 44.2374 58.9683 48.5625V70.6758C58.9683 77.2946 71.046 80.8652 76.3987 87.341C78.5559 89.9512 77.8014 93.6562 74.4259 93.6562Z",
    fill: "url(#paint1_linear_3708_396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_396",
    x1: 55.5008,
    y1: 10.4062,
    x2: 55.5008,
    y2: 100.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2057A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3708_396",
    x1: 55.5011,
    y1: 31.2188,
    x2: 55.5011,
    y2: 93.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2057A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092056"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceLogo);
export default __webpack_public_path__ + "static/media/maintenanceLogo.8d07e810b5c46a4e67e4e75b8e6d3f77.svg";
export { ForwardRef as ReactComponent };